import AbstractApiRepository from '~base/api/AbstractApiRepository';
import { IAxiosResponse } from '~base/api/axios/IAxiosInterfaces';

export default class FileTypesApiRepository extends AbstractApiRepository {
  getFileFormats = (params: URLSearchParams) => {
    return this.apiClient.get<IAxiosResponse<[]>>({
      url: '/AttachedDocuments/GetFileFormats',
      config: { params },
    });
  };

  getDocumentFixedTypes = (params: URLSearchParams) => {
    return this.apiClient.get<IAxiosResponse<[]>>({
      url: '/AttachedDocuments/GetDocumentFixedTypes',
      config: { params },
    });
  };
}
